import React from 'react'
import WeddingSection from './WeddingSection'
import CountDown from 'components/CountDown';

export default function CountdownSection({ weddingInfo }) {
  return (
    <WeddingSection>
        <div 
          // className='no-wedding-padding-x'
          style={{
            padding: "30px 0px"
          }}
        >
            <CountDown time={weddingInfo.open_time}/>
        </div>
    </WeddingSection>
  )
}
